if (!customElements.get('collection-banner-parallax')) {
  customElements.define('collection-banner-parallax',
    class CollectionBannerParallax extends HTMLElement {
      constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.img = null;
      }

      connectedCallback() {
        this.img = this.querySelector('[data-parallax-img]');
        if (!this.img) return;

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:load', this.handleScroll.bind(this));
        }

        this.handleScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
      }

      handleScroll() {
        if (!this.img) return;
        const rect = this.getBoundingClientRect();
        const parallaxSpeed = 0.2;
        const yPos = -(rect.top * parallaxSpeed);
        gsap.set(this.img, { y: yPos, force3D: true });
      }
    }
  );
}
